import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import PhotoFrame from './PhotoFrame';

const SortablePhotoFrame = (props) => {
  const { photo, activeIndex } = props;
  const { attributes, listeners, isDragging, index, over, setNodeRef } = useSortable({
    id: photo.id,
  });

  return (
    <PhotoFrame
      ref={setNodeRef}
      active={isDragging}
      insertPosition={
        activeIndex !== undefined && over?.id === photo.id && !isDragging
          ? index > activeIndex
            ? 'after'
            : 'before'
          : undefined
      }
      aria-label="sortable image"
      attributes={attributes}
      listeners={listeners}
      imageId={photo.id}
      {...props}
    />
  );
};
export default SortablePhotoFrame;
